export default "__VITE_ASSET__BGeU75ix__"